module.exports = __webpack_public_path__ + "static/media/Repeat_Payment.0e2c6ea5.svg";